import { TFunction } from 'i18next';

export const parseReplayTime = (seconds: number, t: TFunction): string => {
  const hours = Math.floor(seconds / 60 / 60);
  if (hours) return t('common.hours', { count: hours });
  const minutes = Math.floor((seconds / 60) % 60);
  return t('common.minutes', { count: minutes });
};
